import request from 'services/axios'

// Category chips. The backend returns a fixed list of {title, key}; the list
// screen prepends a client-side "همه" (empty key = no tag filter).
export const getAnnounceTags = async (mpId: string) => {
    const { data } = await request.get<IAnnounceTag[]>(
        `/announce/tags/${mpId}/`
    )
    return data
}

// Paginated (5/page) history for a category. Empty `tags` = "همه".
export const getAnnounceList = async (
    mpId: string,
    page: number,
    tags?: string
) => {
    const { data } = await request.get<IAnnounceListResponse>(
        `/announce/get_announce/${mpId}/?page=${page}${
            tags ? `&tags=${tags}` : ''
        }`
    )
    return data
}

// Per-recipient delivery status + cost for one announcement (paginated 5/page).
export const getAnnounceDetails = async (
    mpId: string,
    announceId: string,
    page: number
) => {
    const { data } = await request.get<IAnnounceDetailsResponse>(
        `/announce/get_announce_details/${mpId}/announce_id/${announceId}/?page=${page}`
    )
    return data
}
